import { sizeEstimator } from "../../../components/cards/hooks/useGridCardDimensions";
import { Section } from "../../../types";

export const SECTION_ROW_BOTTOM_PADDING = 42;

const SECTION_TITLE_MARGIN_MOBILE = 16;
const SECTION_TITLE_MARGIN_DESKTOP = 22;
// Vertical cards have a hover animation that adds a margin on top, so the
// section title margin is reduced to compensate.
const SECTION_TITLE_VERTICAL_CARD_OFFSET = 6;

export function getSectionTitleMargin(
  isSmallScreen: boolean,
  isVerticalGridCard = false,
): string {
  const base = isSmallScreen
    ? SECTION_TITLE_MARGIN_MOBILE
    : SECTION_TITLE_MARGIN_DESKTOP;
  const offset = isVerticalGridCard ? SECTION_TITLE_VERTICAL_CARD_OFFSET : 0;
  return `${base - offset}px`;
}

export function measureItemVertical(item: Section | undefined): number {
  if (!item) {
    return 0;
  }

  const { context, mode, size } = item.meta.layout.style;
  const dimensions = sizeEstimator(context, mode, size);

  const sectionTitleHeight = item.description ? 88 : 56;

  return dimensions.height + SECTION_ROW_BOTTOM_PADDING + sectionTitleHeight;
}

export function measureItemHorizontal(item: Section | undefined): number {
  if (!item) {
    return 0;
  }

  const { context, mode, size } = item.meta.layout.style;
  const dimensions = sizeEstimator(context, mode, size);

  return dimensions.width;
}
